module.exports = __webpack_public_path__ + "assets/images/rbyearend-15-desktop.jpg?v=2d1922f9";